import React, { useState } from "react";
import Button from "components/CustomButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import TeamInformationDialogMicrosoftTeams from "components/TeamInformationDialogMicrosoftTeams";
import TodoListDialogMicrosoftTeams from "components/TodoListDialogMicrosoftTeams";
import SurveyDialogMicrosoftTeams from "components/SurveyDialogMicrosoftTeams";
import PollListMicrosoftTeams from "components/PollListMicrosoftTeams";
import TeamDashboard from "views/MicrosoftTeams/TeamDashboard/TeamDashboard";
import WellnessMicrosoftTeams from "components/WellnessMicrosoftTeams";
import { CSSTransition } from "react-transition-group";

export default () => {
  const [openButton, setButton] = useState(false);

  return (
    <>
      <Button
        buttonClass="invite-btn text-center microsoftTeamInformationButton"
        onClick={() => setButton(!openButton)}
      >
        More Option
        <span style={{ paddingLeft: "5px" }}>
          {!openButton && <FontAwesomeIcon icon={faArrowDown} />}
          {openButton && <FontAwesomeIcon icon={faArrowUp} />}
        </span>
      </Button>
      <CSSTransition
        in={openButton}
        unmountOnExit
        timeout={300}
        classNames="moreButton-element"
      >
        <div>
          <TodoListDialogMicrosoftTeams />
          <TeamInformationDialogMicrosoftTeams />
          <PollListMicrosoftTeams />
          <TeamDashboard />
          <WellnessMicrosoftTeams />
          <SurveyDialogMicrosoftTeams />
        </div>
      </CSSTransition>
    </>
  );
};
